import React, { useState } from "react";
import { defaultStyles } from "../../../constants/style-constants/utils";
// import Modal from "./Modal";
import helpIcon from "../../../assets/images/DeathModuleNew/IC_Help.png";
import { Button } from "../../../components/styled-components/button";
import fileIcon from "../../../assets/images/DeathModuleNew/Icons.png";
import Loader from "../../../components/styled-components/loader/loader";
import * as Style from "../styles/ModalStyle";
import { Icon, Modal, Select, Row, Col, Radio, Input } from "antd";
import Currency from "../../../components/form/Currency";
import { InputGroup } from "../../../components/inputGroup/InputGroup";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import PhoneNum from "../../../components/form/components/Countrycode";
import TextArea from "antd/lib/input/TextArea";
import WebAddress from "../../../components/form/WebAddress";
import swal from "sweetalert";
import { DatePicker } from "antd";
import moment from "moment";
import DEATH_API from "../../../apis/death.api";
import { AutoComplete } from 'antd';

const { Option } = Select;

function UpdateModal({
  show,
  close,
  fields,
  submitData,
  modalTitle,
  handlechange,
  handleDocumentChange,
  handleDatePickerChange,
  handleRadioChange,
  obj,
  handleUpdatePhoneChange,
  handleUpdateRichTextChange,
  handleSelectUpdateTemplateChange,
  handleSelectUpdateTextTemplateChange,
  handleUpdateSelectChange,
  handleUpdateCurrencychange,
}) {
  const { styles } = defaultStyles;
  const [formData, setFormData] = useState({});
  const [textField, setTextField] = useState(false);
  const [loading, setLoading] = useState(false);
  const [templateDesign, setTemplateDesign] = useState("");
  const [selectedRadio, setSelectedRadio] = useState(null);
  const [tooltipModalTrustee, setTooltipModalTrustee] = useState(false);
  const [tooltipModalPassword, setTooltipModalPassword] = useState(false);

  const [selectListCustomtext, setselectListCustomtext] = useState({});
  const handleSubmit = () => {
    submitData();
    // close();
  };
  const showTooltipModalTrustee = () => {
    setTooltipModalTrustee(true);
  };

  const handleTooltipCancelTrustee = () => {
    setTooltipModalTrustee(false);
  };

  const showTooltipModalPassword = () => {
    setTooltipModalPassword(true);
  };

  const handleTooltipCancelPassword = () => {
    setTooltipModalPassword(false);
  };
  // const handleChange = (e) => {
  //   const { name, value } = e.target;
  //   setFormData((prevFormData) => ({
  //     ...prevFormData,
  //     [name]: value,
  //   }));
  // };
  console.log("obj....", obj);

  for (let i = 0; i < fields.length; i++) {
    console.log("fieldssssss", fields[i]);
  }
  return (
    <Modal footer={null} closable={false} visible={show} centered>
      {console.log("show in modal", show)}
      <Style.HeaderConatiner>
        <Style.ModalTitle> {modalTitle}</Style.ModalTitle>
        {/* <Icon type="close" onClick={close}></Icon> */}
      </Style.HeaderConatiner>

      <div
        style={{
          marginTop: "1rem",
          maxHeight: "25rem",
          overflow: "scroll",
          padding: "1rem",
        }}>
        {fields.map((item, idx) => {
          const {
            title,
            type,
            options = [],
            index = null,
            isRequired = false,
            def = null,
            isDisabled = false,
          } = item;
          switch (type) {
            case "email":
              return (
                <div key={idx} style={{ marginTop: "8px" }}>
                  <Style.FieldsTitle>{item.title}</Style.FieldsTitle>
                  <Style.Input
                    defaultValue={def}
                    value={obj ? obj[index] : ""}
                    name={item.title}
                    onChange={(e) => {
                      obj[index] = e.target.value;
                      handlechange(e);
                    }}
                    // onChange={(val) => {
                    //   if (currentForm) {
                    //     handleInputChange(val, currentForm);
                    //     setFormData({
                    //       [index]: val.target.value,
                    //     });
                    //   } else {
                    //     this.setState({
                    //       form: {
                    //         ...this.state.form,
                    //         [index]: val.target.value,
                    //       },
                    //     });
                    //   }
                    // }}
                    size="large"
                    placeholder={`Enter ${title}`}
                    // name="client_primaryContactNumber"
                  ></Style.Input>
                </div>
              );
            case "email1":
              return (
                <div key={idx} style={{ marginTop: "8px" }}>
                  <Style.FieldsTitle>{item.title}</Style.FieldsTitle>
                  <Style.Input
                    defaultValue={def}
                    value={obj ? obj[index] : ""}
                    style={{ cursor: "not-allowed" }}
                    name={item.title}
                    disabled={true}
                    onChange={(e) => {
                      obj[index] = e.target.value;
                      handlechange(e);
                    }}
                    // onChange={(val) => {
                    //   if (currentForm) {
                    //     handleInputChange(val, currentForm);
                    //     setFormData({
                    //       [index]: val.target.value,
                    //     });
                    //   } else {
                    //     this.setState({
                    //       form: {
                    //         ...this.state.form,
                    //         [index]: val.target.value,
                    //       },
                    //     });
                    //   }
                    // }}
                    size="large"
                    placeholder={`Enter ${title}`}
                    // name="client_primaryContactNumber"
                  ></Style.Input>
                </div>
              );
            case "input":
              return (
                <div key={idx} style={{ marginTop: "8px" }}>
                  <Style.FieldsTitle>{item.title}</Style.FieldsTitle>
                  {/* <Form.Item label={title} validateStatus={"error"}> */}
                  {title === "2FA" ? (
                    <Input
                      // defaultValue={def}
                      value={obj ? obj[index] : ""}
                      // defaultValue={obj ? obj[index] : ""}
                      // disabled={isDisabled}
                      // name={index}
                      name={item.title}
                      onChange={(e) => {
                        obj[index] = e.target.value;
                        handlechange(e);
                        console.log(e.target.value);
                      }}
                      // onChange={(val) => {
                      //   if (currentForm) {
                      //     handleInputChange(val, currentForm);
                      //     setFormData({
                      //       [index]: val.target.value,
                      //     });
                      //   } else {
                      //     this.setState({
                      //       form: {
                      //         ...this.state.form,
                      //         [index]: val.target.value,
                      //       },
                      //     });
                      //   }
                      // }}
                      size="large"
                      placeholder={`Google Auth, YubiKey, SMS/Text, etc.`}
                      // name="client_primaryContactNumber"
                    ></Input>
                  ) : (
                    <Input
                      // defaultValue={def}
                      disabled={isDisabled}
                      value={obj ? obj[index] : ""}
                      // defaultValue={obj ? obj[index] : ""}
                      // name={index}
                      name={item.title}
                      onChange={(e) => {
                        obj[index] = e.target.value;
                        handlechange(e);
                        console.log(e.target.value);
                      }}
                      // onChange={(val) => {
                      //   if (currentForm) {
                      //     handleInputChange(val, currentForm);
                      //     setFormData({
                      //       [index]: val.target.value,
                      //     });
                      //   } else {
                      //     this.setState({
                      //       form: {
                      //         ...this.state.form,
                      //         [index]: val.target.value,
                      //       },
                      //     });
                      //   }
                      // }}
                      size="large"
                      placeholder={`Enter ${title}`}
                      // name="client_primaryContactNumber"
                    ></Input>
                  )}
                </div>
              );
            case "emails":
              return (
                <div key={idx} style={{ marginTop: "8px" }}>
                  {/* <Form.Item label={title} validateStatus={"error"}> */}
                  <Style.FieldsTitle>{item.title}</Style.FieldsTitle>
                  <Style.Input
                    // className="custom-input"
                    defaultValue={def}
                    disabled={isDisabled}
                    value={obj ? obj[index] : ""}
                    name={index}
                    onChange={(e) => {
                      handlechange(e);
                    }}
                    // onChange={(val) => {
                    //   if (currentForm) {
                    //     handleInputChange(val, currentForm);
                    //     setFormData({
                    //       [index]: val.target.value,
                    //     });
                    //   } else {
                    //     this.setState({
                    //       form: {
                    //         ...this.state.form,
                    //         [index]: val.target.value,
                    //       },
                    //     });
                    //   }
                    // }}
                    size="large"
                    placeholder={`Enter ${title}`}
                    // name="client_primaryContactNumber"
                  ></Style.Input>
                </div>
              );
            case "phoneNumber1":
              return (
                <div key={idx} style={{ marginTop: "8px" }}>
                  {/* <Form.Item label={title} validateStatus={"error"}> */}
                  <Style.FieldsTitle>{item.title}</Style.FieldsTitle>
                  <PhoneNum
                    defaultValue={def}
                    disabled={true}
                    name={index}
                    value={obj ? obj[index] : ""}
                    onChange={(e) => {
                      // handlechange(e);
                      handleUpdatePhoneChange(item.title, e.target.value);
                    }}
                    // onChange={(val) => {
                    //   // console.log("phone with country code=>>", val.target.value)
                    //   if (currentForm) {
                    //     handleInputChange(val, currentForm);
                    //     // console.log("value phone..", val);
                    //     setFormData({
                    //       [index]: val.target.value,
                    //     });
                    //   } else {
                    //     this.setState({
                    //       form: {
                    //         ...this.state.form,
                    //         [index]: val.target.value,
                    //       },
                    //     });
                    //   }
                    // }}
                    size="large"
                    placeholder={`Enter ${title}`}
                    // name="client_primaryContactNumber"
                  ></PhoneNum>
                </div>
              );
            case "phoneNumber":
              return (
                <div key={idx} style={{ marginTop: "8px" }}>
                  {/* <Form.Item label={title} validateStatus={"error"}> */}
                  {modalTitle==="Update Prepaid Burial Expenses" &&
                  <Style.FieldsTitle>{item.title}</Style.FieldsTitle>
                 }
                  <PhoneNum
                    defaultValue={def}
                    disabled={isDisabled}
                    name={index}
                    value={obj ? obj[index] : ""}
                    onChange={(e) => {
                      // handlechange(e);
                      handleUpdatePhoneChange(item.title, e.target.value);
                    }}
                    // onChange={(val) => {
                    //   // console.log("phone with country code=>>", val.target.value)
                    //   if (currentForm) {
                    //     handleInputChange(val, currentForm);
                    //     // console.log("value phone..", val);
                    //     setFormData({
                    //       [index]: val.target.value,
                    //     });
                    //   } else {
                    //     this.setState({
                    //       form: {
                    //         ...this.state.form,
                    //         [index]: val.target.value,
                    //       },
                    //     });
                    //   }
                    // }}
                    size="large"
                    placeholder={`Enter ${title}`}
                    // name="client_primaryContactNumber"
                  ></PhoneNum>
                </div>
              );
            case "phoneNumberA":
              return (
                <div key={idx} style={{ marginTop: "8px" }}>
                  {/* <Form.Item label={title} validateStatus={"error"}> */}
                  <Style.FieldsTitle>{item.title}</Style.FieldsTitle>
                  <PhoneNum
                    defaultValue={def}
                    disabled={isDisabled}
                    name={index}
                    value={obj ? obj[index] : ""}
                    onChange={(e) => {
                      // handlechange(e);
                      handleUpdatePhoneChange(item.title, e.target.value);
                    }}
                    // onChange={(val) => {
                    //   // console.log("phone with country code=>>", val.target.value)
                    //   if (currentForm) {
                    //     handleInputChange(val, currentForm);
                    //     // console.log("value phone..", val);
                    //     setFormData({
                    //       [index]: val.target.value,
                    //     });
                    //   } else {
                    //     this.setState({
                    //       form: {
                    //         ...this.state.form,
                    //         [index]: val.target.value,
                    //       },
                    //     });
                    //   }
                    // }}
                    size="large"
                    placeholder={`Enter ${title}`}
                    // name="client_primaryContactNumber"
                  ></PhoneNum>
                </div>
              );
            case "currency":
              return (
                <div key={idx} style={{ marginTop: "8px" }}>
                  <Style.FieldsTitle>{item.title}</Style.FieldsTitle>
                  <Currency
                    id={index}
                    value={obj ? obj[index] : ""}
                    placeholder={`Enter ${title}`}
                    name={item.title}
                    onChange={(event) => {
                      event.preventDefault();
                      console.log("amount", event.target.value);
                      handleUpdateCurrencychange(event);
                      // handlechange(event);
                    }}></Currency>
                </div>
              );
            case "multiple":
              return (
                <div key={idx} style={{ marginTop: "8px" }}>
                  <Style.FieldsTitle>{item.title}</Style.FieldsTitle>
                  <Style.Input
                    required={isRequired}
                    value={obj ? obj[index] : ""}
                    onChange={(e) => {
                      handlechange(e);
                    }}
                    // onChange={(val) =>
                    //   this.setState({
                    //     form: {
                    //       ...this.state.form,
                    //       [index]: val.target.value,
                    //     },
                    //   })
                    // }
                    size="large"
                    placeholder={`Enter ${title}`}
                    name="client_primaryContactNumber"></Style.Input>
                </div>
              );

              case "selectEmail":
                return (
                  <div key={idx} style={{ marginTop: "8px" }}>
                    <Style.FieldsTitle>
                       {item.title}
                    </Style.FieldsTitle>
                    <AutoComplete
                      dataSource={options}
                      value={obj ? obj[index] : ""}
                      // disabled={obj && obj["groupId"] && item.title==="To" ? true : false}
                      onSelect={(e)=>{
                      console.log("newvalue",e)
                      handleUpdateSelectChange(index, e);

                      }}
                      onSearch={(e)=>{
                        handleUpdateSelectChange(index, e);
                      }}
                    onChange={(e,value)=>{
                    console.log("autocomplte",e,value)
                    }}
                    placeholder="Enter Email"
                    // filterOption={(inputValue, option) =>
                    //   option.props.children.toUpperCase().indexOf(inputValue.toUpperCase()) !== -1
                    // }
                  />
                  </div>
                );
                case "selectNumber":
                  return (
                    <div key={idx} style={{ marginTop: "8px" }}>
                      <Style.FieldsTitle>
                         {item.title}
                      </Style.FieldsTitle>
                      <AutoComplete
                        dataSource={options}
                        value={obj ? obj[index] : ""}
                        // disabled={obj && obj["groupId"] && item.title==="TextTo" ? true : false}
                        onSelect={(e)=>{
                        console.log("newvalue",e)
                        handleUpdateSelectChange(index, e);
                        }}
                        onSearch={(e)=>{
                          handleUpdateSelectChange(index, e);
                        }}
                      onChange={(e,value)=>{
                      console.log("autocomplte",e,value)
                      }}
                      placeholder="Enter Number"
                      // filterOption={(inputValue, option) =>
                      //   option.props.children.toUpperCase().indexOf(inputValue.toUpperCase()) !== -1
                      // }
                    />
                    </div>
                  );


            case "select":
              return (
                <div key={idx} style={{ marginTop: "8px" }}>
                  <Style.FieldsTitle>{item.title}</Style.FieldsTitle>
                  <Select
                    showSearch
                    value={obj ? obj[index] : ""}
                    disabled={obj && obj["to"] && item.title==="To Group" ? true : false}
                    placeholder="-Select-"
                    name={title}
                    onChange={(value, id) => {
                      console.log("value", id.key);
                      if (value) {
                        handleUpdateSelectChange(index, value);
                        if (index === "Templates") {
                          try {
                            (async () => {
                              setLoading(true);
                              // isLoading=true
                              const data = await DEATH_API.fetchEmailTemplates(
                                id.key
                              );
                              // isLoading=false
                              setLoading(false);
                              console.log("data for template", data);
                              if (data && data.data.template) {
                                handleSelectUpdateTemplateChange(index, id.key);
                                setFormData((prevFormData) => ({
                                  ...prevFormData,
                                  ["Template"]: data.data.template,
                                  ["TemplateID"]: id.key,
                                }));
                                setTemplateDesign(data.data.template);
                              }
                            })();
                          } catch (error) {
                            setLoading(false);
                            // this.props.handleLoader()
                            // console.group(error)
                          }
                        }
                        if (index === "TextTemplates") {
                          console.log("value", value);
                          try {
                            (async () => {
                              setLoading(true);
                              // isLoading=true
                              const data = await DEATH_API.fetchTextTemplates(
                                id.key
                              );
                              // isLoading=false
                              setLoading(false);
                              console.log(
                                "data for template",
                                data.data.template
                              );
                              if (data && data.data.template) {
                                handleSelectUpdateTextTemplateChange(
                                  index,
                                  id.key
                                );
                                setFormData((prevFormData) => ({
                                  ...prevFormData,
                                  ["Template"]: data.data.template,
                                  ["TemplateID"]: id.key,
                                }));
                                setTemplateDesign(data.data.template);
                              }
                            })();
                          } catch (error) {
                            setLoading(false);
                            // this.props.handleLoader()
                            // console.group(error)
                          }
                        }
                        // if (value === "Others") {
                        //   // this.setState({textField:true});
                        //   this.setState({
                        //     selectListCustomtext: { ...this.state.selectListCustomtext, [index]: true }
                        //   })
                        //   // console.log("other is selected..",this.state.textField);
                        // }
                        else {
                          setFormData({
                            [index]: value,
                          });
                        }
                      } else {
                        // this.setState({
                        //   form: {
                        //     ...this.state.form,
                        //     [index]: value,
                        //   },
                        // });
                        setFormData({
                          ["TemplateID"]: id.key,
                        });
                      }
                    }}>
                    {index === "TextTemplates" &&
                      // console.log("options text", options)

                      options &&
                      options.map((item, index) => {
                        return (
                          <Option key={item.id} value={item.name}>
                            {item.name}
                          </Option>
                        );
                      })}
                    {index === "Templates" &&
                      // console.log("options email", options)
                      options &&
                      options.map((item, index) => {
                        return (
                          <Option key={item.id} value={item.name}>
                            {item.name}
                          </Option>
                        );
                      })}
                    {index !== "Templates" &&
                      index !== "TextTemplates" &&
                      options &&
                      options.map((item, index) => {
                        return (
                          <Option key={index} value={item}>
                            {item}
                          </Option>
                        );
                      })}
                  </Select>

                  {/*      {this.state.textField && <div className="custom-field-align">

                    <Style.Input
                      // id="section"
                      id={`section${index}`}
                      // className="field-set"
                      name={title}
                      type="text"
                      placeholder={`Enter ${title}`}
                      size={"large"}
                      onChange={(e) => {
                        // console.log("value....", e.target.value)
                      }}
                    />
                    <Button
                      className="button-set"
                      onClick={() => {
                        const value = document.getElementById(`section${index}`).value;
                        console.log("value.. saved", value);
                        setFormData({
                          [index]: value,
                        });
                        this.setState({textField:false});
                      }

                      }
                    >
                      OK
                    </Button>{" "}
                    </div>}  */}
                </div>
              );

            case "date":
              return (
                <div key={idx} style={{ marginTop: "8px" }}>
                  {console.log("Date", obj && obj[index])}
                  <Style.FieldsTitle>{item.title}</Style.FieldsTitle>
                  <DatePicker
                  id="newDate"
                    size="large"
                    style={{ width: "100%", border:"1px solid #d1d5db", borderRadius:"5px", }}
                    value={
                      (formData &&
                        formData[index] &&
                        moment(formData[index])) ||
                      (obj && obj[index] && moment(obj[index])) ||
                      null
                    }
                    // defaultValue={
                    //   (obj && obj[index] && moment(obj[index])) || null
                    // }
                    format={"MM/DD/YYYY"}
                    name={item.title}
                    onChange={(date, dateString) => {
                      handleDatePickerChange(item.title, dateString);
                      console.log("momentmoment", date);
                      setFormData({
                        [index]: date,
                      });
                    }}
                  />
                </div>
              );

            case "textarea":
              return (
                <div key={idx} style={{ marginTop: "8px" }}>
                  {console.log("obj[index]", obj && obj[index])}
                  <Style.FieldsTitle>{item.title}</Style.FieldsTitle>
                  <TextArea
                    id={index}
                    placeholder="Enter Notes"
                    name={index}
                    value={obj ? obj[index] : ""}
                    onChange={handlechange}
                    // onChange={(e) => {
                    //   handleInputChange(e, currentForm);
                    //   setFormData({
                    //     [index]: e.target.value,
                    //   });
                    // }}
                  />
                </div>
              );

            case "richtext1":
              return (
                <div>
                  <Style.FieldsTitle>{item.title}</Style.FieldsTitle>
                  <ReactQuill
                    readOnly={false}
                    value={
                      formData.Template ||
                      (obj && obj[index] && obj[index]) ||
                      null
                    }
                    onChange={(e) => {
                      console.log("eeeee", e);
                      setFormData((prevFormData) => ({
                        ...prevFormData,
                        [index]: e,
                      }));
                      handleUpdateRichTextChange(index, e);
                      // setFormData({
                      //   [index]: e
                      // });
                    }}
                    // value={formData.Template || null}
                    // onChange={(e) => {
                    //   handleRichTextChange(index, e, currentForm);
                    //   setFormData({
                    //     [index]: e
                    //   });

                    //   console.log('background', e);
                    // }}
                  />
                </div>
              );
              case "richtext2":
                return (
                  <div>
                    <Style.FieldsTitle>{item.title}</Style.FieldsTitle>
                    <ReactQuill
                      readOnly={false}
                      modules={{ toolbar: false }}
                      value={
                        formData.Template ||
                        (obj && obj[index] && obj[index]) ||
                        null
                      }
                      onChange={(e) => {
                        console.log("eeeee", e);
                        setFormData((prevFormData) => ({
                          ...prevFormData,
                          [index]: e,
                        }));
                        handleUpdateRichTextChange(index, e);
                        // setFormData({
                        //   [index]: e
                        // });
                      }}
                      // value={formData.Template || null}
                      // onChange={(e) => {
                      //   handleRichTextChange(index, e, currentForm);
                      //   setFormData({
                      //     [index]: e
                      //   });
  
                      //   console.log('background', e);
                      // }}
                    />
                  </div>
                );
            case "richtext":
              return (
                <div style={{ marginTop: "8px" }}>
                  <Style.FieldsTitle>{item.title}</Style.FieldsTitle>
                  <ReactQuill
                    value={formData.Template || null}
                    // value={templateState && this.state.templateState || (obj && obj["Template"]) && obj["Template"]}

                    onChange={(e) => {
                      handleUpdateRichTextChange(index, e);
                      // setFormData({
                      //   [index]: e
                      // });
                    }}
                    // onChange={(e) => {
                    //   handleRichTextChange(index, e, currentForm);
                    //   setFormData({
                    //     [index]: e
                    //   });

                    //   console.log('background', e);
                    // }}
                  />
                </div>
              );

            case "radio":
              return (
                <div key={idx} style={{ marginTop: "8px" }}>
                  {item.title === "*Trusted Individual*" ||
                  item.title === "Second Password Granted" ? (
                    <React.Fragment>
                      <div style={{ display: "flex" }}>
                        <Style.FieldsTitle>{item.title}</Style.FieldsTitle>
                        <img
                          style={{
                            cursor: "pointer",
                            marginLeft: "8px",
                            width: "25px",
                            height: "25px",
                            marginTop: "10px",
                          }}
                          src={helpIcon}
                          alt="helpicon"
                          onClick={() => {
                            if (item.title === "*Trusted Individual*") {
                              showTooltipModalTrustee();
                            } else if (
                              item.title === "Second Password Granted"
                            ) {
                              showTooltipModalPassword();
                            }
                          }}></img>
                      </div>
                    </React.Fragment>
                  ) : (
                    <div style={{ display: "flex" }}>
                      {" "}
                      <Style.FieldsTitle>{item.title}</Style.FieldsTitle>
                    </div>
                  )}
                  <Modal
                    centered
                    visible={tooltipModalTrustee}
                    footer={null}
                    onCancel={handleTooltipCancelTrustee}>
                    <Style.ModalTitle> Trusted Individual</Style.ModalTitle>
                    <div style={{}}>
                      <div className="">
                        <Style.ModalDetails>
                          When Trusted Individuals are added, they become
                          “delegates”. Trusted Individuals will receive an
                          invitation email from Asset Planet and if activated,
                          they will have complete access to your information
                          upon your passing. Read more in our Knowledgebase.
                        </Style.ModalDetails>
                      </div>
                    </div>
                  </Modal>
                  <Modal
                    centered
                    visible={tooltipModalPassword}
                    footer={null}
                    onCancel={handleTooltipCancelPassword}>
                    <Style.ModalTitle>
                      {" "}
                      Second Password Granted
                    </Style.ModalTitle>
                    <div style={{}}>
                      <div className="">
                        <Style.ModalDetails>
                          Second Password Granted gives a Trusted Individual
                          access to your List of Password module and your
                          Important Documents module upon entering a valid OTP.
                          These modules are only accessible after your passing.
                          Read more in our Knowledgebase.
                        </Style.ModalDetails>
                      </div>
                    </div>
                  </Modal>

                  <Radio.Group
                    // defaultValue={obj && obj[index] ? "Yes" : "No"}
                    value={
                      (obj &&
                        ((obj[index] === true && "Yes") ||
                          (obj[index] === false && "No"))) ||
                      (obj && obj[index] === "Yes" ? "Yes" : "No")
                    }
                    onChange={(e) => {
                      console.log(
                        "e.target.value radio",
                        index,
                        e.target.value
                      );
                      // setSelectedRadio(e.target.value);
                      // obj[index]=e.target.value;
                      handleRadioChange(index, e.target.value);
                    }}>
                    {["Yes", "No"].map((value, vindex) => (
                      <Radio.Button key={vindex} value={value}>
                        {value}
                      </Radio.Button>
                    ))}
                  </Radio.Group>
                </div>
              );
            case "radio1":
              return (
                <div key={idx} style={{ marginTop: "8px" }}>
                  <Style.FieldsTitle>{item.title}</Style.FieldsTitle>
                  {console.log("obj ? obj[index]", index, obj && obj[index])}
                  {console.log(
                    "helooooo",
                    (obj &&
                      obj[index] === true &&
                      "Yes" &&
                      obj &&
                      obj[index] === false &&
                      "No") ||
                      (obj && obj[index] === "Yes")
                      ? "Yes"
                      : "No"
                  )}
                  <Radio.Group
                    // value={
                    //   (obj &&
                    //     ((obj[index] === true && "Yes") ||
                    //       (obj[index] === false && "No"))) ||
                    //   (obj && obj[index] === "Yes" ? "Yes" : "No")
                    // }
                    value={obj ? obj[index] : ""}
                    onChange={(e) => {
                      console.log(
                        "e.target.value radio",
                        index,
                        e.target.value
                      );
                      // setSelectedRadio(e.target.value);
                      // obj[index]=e.target.value;
                      handleRadioChange(index, e.target.value);
                    }}>
                    {["Yes", "No", "50/50"].map((value, vindex) => (
                      <Radio.Button key={vindex} value={value}>
                        {value}
                      </Radio.Button>
                    ))}
                  </Radio.Group>
                </div>
              );

            case "web":
              return (
                <div>
                  <Style.FieldsTitle>{item.title}</Style.FieldsTitle>
                  <WebAddress
                    placeholder={`Enter ${title}`}
                    value={formData[index] || null}
                    // onChange={(event) => {
                    //   // console.log("phone",event.target.name);
                    //   // handleWebChange(
                    //   //   index,
                    //   //   event.target.value,
                    //   //   currentForm
                    //   // );
                    //   setFormData({
                    //     [index]: event.target.value,
                    //   });
                    // }}
                    disabled={isDisabled}
                  />
                </div>
              );

            case "document":
              return (
                <div style={{ marginTop: "8px" }}>
                  <Style.FieldsTitle>{item.title}</Style.FieldsTitle>
                  <div className="custom-upload-style">
                    <Style.Input
                      id="file-input"
                      type="file"
                      // onChange={(event) => {
                      //   // console.log("document", event.target.files[0]);
                      //   console.log("document size", event.target.files[0].size);
                      //   const fileSize = event.target.files[0].size / (1024 * 1000)// in MB
                      //   console.log("fileSize in mb", fileSize)
                      //   if (fileSize < 100) {
                      //     if (currentForm) {
                      //       handleDocumentChange(
                      //         index,
                      //         event.target.files[0],
                      //         currentForm
                      //       );
                      //       setFormData({
                      //         [index]: event.target.files[0].name,
                      //         file: event.target.files[0]
                      //       });
                      //     } else {
                      //       this.setState({
                      //         form: {
                      //           ...this.state.form,
                      //           [index]: event.target.files[0],
                      //         },
                      //       });
                      //     }
                      //   }
                      //   else {
                      //     swal("Oops!", "File size is large! (Max allowed 100MB)", "error");
                      //   }
                      // }}
                    />
                    <label for="file-input">
                      <Icon
                        className="mt-1"
                        style={{
                          fontSize: "23px",
                          background: "#39b54a",
                          padding: "8px",
                          borderRadius: "5px",
                          color: "white",
                        }}
                        type="upload"></Icon>
                    </label>
                  </div>
                </div>
              );
            case "file":
              return (
                <div style={{ marginTop: "1rem" }}>
                  {console.log("indexfile", obj && obj)}
                  <Style.FieldsTitle>{item.title}</Style.FieldsTitle>
                  <div className="">
                    <Style.Input
                      // id="file-input"
                      id="file"
                      type="file"
                      // value={obj ? obj[index] : ""}
                      name={item.title}
                      // onChange={(e)=>{handlechange(e)}}
                      style={{
                        width: "80%",
                        display: "none",
                        marginRight: "10px",
                      }}
                      onChange={(event) => {
                        // console.log("document", event.target.files[0]);
                        console.log(
                          "document size",
                          event.target.files[0].size
                        );
                        const fileSize =
                          event.target.files[0].size / (1024 * 1000); // in MB
                        console.log("fileSize in mb", fileSize);
                        if (fileSize < 100) {
                          handleDocumentChange(
                            item.title,
                            event.target.files[0]
                          );
                          document.getElementById("filechose").innerHTML =
                            event.target.files[0].name;
                          // if (currentForm) {
                          //   handleDocumentChange(
                          //     index,
                          //     event.target.files[0],
                          //     currentForm
                          //   );
                          //   setFormData({
                          //     [index]: event.target.files[0].name,
                          //     file: event.target.files[0],
                          //   });
                          // } else {
                          //   this.setState({
                          //     form: {
                          //       ...this.state.form,
                          //       [index]: event.target.files[0],
                          //     },
                          //   });
                          // }
                        } else {
                          swal(
                            "Oops!",
                            "File size is large! (Max allowed 100MB)",
                            "error"
                          );
                        }
                      }}
                      accept="image/jpeg, .pdf, .xlsx, .doc"
                    />
                    <Style.FileLabel
                      htmlFor="file"
                      style={{ width: "100%" }}
                      className="file">
                      <Style.FileBlock
                        id="filechose"
                        style={{ marginRight: "10px" }}>
                        {(obj && obj[index] && "File Exists") ||
                          "No file Choosen"}
                        <img src={fileIcon} alt="fileIcon"></img>
                      </Style.FileBlock>
                      <Style.FileBlockButton>Browse</Style.FileBlockButton>{" "}
                    </Style.FileLabel>
                  </div>
                </div>
              );
            case "Image":
              return (
                <div style={{ marginTop: "1rem" }}>
                  {console.log("indexfile", obj && obj)}
                  <Style.FieldsTitle>{item.title}</Style.FieldsTitle>
                  <div className="">
                    <Style.Input
                      // id="file-input"
                      id="file"
                      type="file"
                      // value={obj ? obj[index] : ""}
                      name={item.title}
                      // onChange={(e)=>{handlechange(e)}}
                      style={{
                        width: "80%",
                        display: "none",
                        marginRight: "10px",
                      }}
                      onChange={(event) => {
                        // console.log("document", event.target.files[0]);
                        console.log(
                          "document size",
                          event.target.files[0].size
                        );
                        const fileSize =
                          event.target.files[0].size / (1024 * 1000); // in MB
                        console.log("fileSize in mb", fileSize);
                        if (fileSize < 100) {
                          handleDocumentChange(
                            item.title,
                            event.target.files[0]
                          );
                          document.getElementById("filechoseImage").innerHTML =
                            event.target.files[0].name;
                          // if (currentForm) {
                          //   handleDocumentChange(
                          //     index,
                          //     event.target.files[0],
                          //     currentForm
                          //   );
                          //   setFormData({
                          //     [index]: event.target.files[0].name,
                          //     file: event.target.files[0],
                          //   });
                          // } else {
                          //   this.setState({
                          //     form: {
                          //       ...this.state.form,
                          //       [index]: event.target.files[0],
                          //     },
                          //   });
                          // }
                        } else {
                          swal(
                            "Oops!",
                            "File size is large! (Max allowed 100MB)",
                            "error"
                          );
                        }
                      }}
                      accept="image/*"
                    />
                    <Style.FileLabel
                      htmlFor="file"
                      style={{ width: "100%" }}
                      className="file">
                      <Style.FileBlock
                        id="filechoseImage"
                        style={{ marginRight: "10px" }}>
                        {(obj && obj[index] && "File Exists") ||
                          "No file Choosen"}
                        <img src={fileIcon} alt="fileIcon"></img>
                      </Style.FileBlock>
                      <Style.FileBlockButton>Browse</Style.FileBlockButton>{" "}
                    </Style.FileLabel>
                  </div>
                </div>
              );
            case "audio":
              return (
                <div style={{ marginTop: "1rem" }}>
                  {console.log("indexfile", obj && obj)}
                  <Style.FieldsTitle>{item.title}</Style.FieldsTitle>
                  <div>{item.title}</div>
                  <div className="">
                    <Style.Input
                      // id="file-input"
                      id="file"
                      type="file"
                      // value={obj ? obj[index] : ""}
                      name={item.title}
                      // onChange={(e)=>{handlechange(e)}}
                      style={{
                        width: "80%",
                        display: "none",
                        marginRight: "10px",
                      }}
                      onChange={(event) => {
                        // console.log("document", event.target.files[0]);
                        console.log(
                          "document size",
                          event.target.files[0].size
                        );
                        const fileSize =
                          event.target.files[0].size / (1024 * 1000); // in MB
                        console.log("fileSize in mb", fileSize);
                        if (fileSize < 100) {
                          handleDocumentChange(
                            item.title,
                            event.target.files[0]
                          );
                          document.getElementById("filechose").innerHTML =
                            event.target.files[0].name;
                          // if (currentForm) {
                          //   handleDocumentChange(
                          //     index,
                          //     event.target.files[0],
                          //     currentForm
                          //   );
                          //   setFormData({
                          //     [index]: event.target.files[0].name,
                          //     file: event.target.files[0],
                          //   });
                          // } else {
                          //   this.setState({
                          //     form: {
                          //       ...this.state.form,
                          //       [index]: event.target.files[0],
                          //     },
                          //   });
                          // }
                        } else {
                          swal(
                            "Oops!",
                            "File size is large! (Max allowed 100MB)",
                            "error"
                          );
                        }
                      }}
                      accept="audio/*"
                    />
                    <Style.FileLabel
                      htmlFor="file"
                      style={{ width: "100%" }}
                      className="file">
                      <Style.FileBlock
                        id="filechose"
                        style={{ marginRight: "10px" }}>
                        {(obj && obj[index] && "File Exists") ||
                          "No file Choosen"}
                        <img src={fileIcon} alt="fileIcon"></img>
                      </Style.FileBlock>
                      <Style.FileBlockButton>Browse</Style.FileBlockButton>{" "}
                    </Style.FileLabel>
                  </div>
                </div>
              );
            case "video":
              return (
                <div style={{ marginTop: "1rem" }}>
                  {console.log("indexfile", obj && obj)}
                  <Style.FieldsTitle>{item.title}</Style.FieldsTitle>
                  <div>{item.title}</div>
                  <div className="">
                    <Style.Input
                      // id="file-input"
                      id={item.title}
                      type="file"
                      // value={obj ? obj[index] : ""}
                      name={item.title}
                      // onChange={(e)=>{handlechange(e)}}
                      style={{
                        width: "80%",
                        display: "none",
                        marginRight: "10px",
                      }}
                      onChange={(event) => {
                        // console.log("document", event.target.files[0]);
                        console.log(
                          "document size",
                          event.target.files[0].size
                        );
                        const fileSize =
                          event.target.files[0].size / (1024 * 1000); // in MB
                        console.log("fileSize in mb", fileSize);
                        if (fileSize < 100) {
                          handleDocumentChange(
                            item.title,
                            event.target.files[0]
                          );
                          document.getElementById("filechose1").innerHTML =
                            event.target.files[0].name;
                          // if (currentForm) {
                          //   handleDocumentChange(
                          //     index,
                          //     event.target.files[0],
                          //     currentForm
                          //   );
                          //   setFormData({
                          //     [index]: event.target.files[0].name,
                          //     file: event.target.files[0],
                          //   });
                          // } else {
                          //   this.setState({
                          //     form: {
                          //       ...this.state.form,
                          //       [index]: event.target.files[0],
                          //     },
                          //   });
                          // }
                        } else {
                          swal(
                            "Oops!",
                            "File size is large! (Max allowed 100MB)",
                            "error"
                          );
                        }
                      }}
                      accept="video/*"
                    />
                    <Style.FileLabel
                      htmlFor={item.title}
                      style={{ width: "100%" }}
                      className="file">
                      <Style.FileBlock
                        id="filechose1"
                        style={{ marginRight: "10px" }}>
                        {(obj && obj[index] && "File Exists") ||
                          "No file Choosen"}
                        <img src={fileIcon} alt="fileIcon"></img>
                      </Style.FileBlock>
                      <Style.FileBlockButton>Browse</Style.FileBlockButton>{" "}
                    </Style.FileLabel>
                  </div>
                </div>
              );
          }
        })}
      </div>

      <Style.WrapperButtons>
        <Style.CancelButton onClick={close}>Cancel</Style.CancelButton>
        <Style.SaveButton onClick={handleSubmit}>Save</Style.SaveButton>
      </Style.WrapperButtons>
      <Loader isLoading={loading} />
    </Modal>
  );
}

export default UpdateModal;
